var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 16",
    clipPath: "url(#clip0_411_13809)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 16,
    cy: 16,
    r: 14.5,
    stroke: "url(#paint0_angular_411_13809)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7",
    d: "M16 7.2002L16.255 8.12711C17.4002 12.2895 20.8109 15.4396 25.051 16.2512L24.615 16.385C20.5564 17.6306 17.3794 20.8075 16.1338 24.8661L16 25.3021L15.8662 24.8661C14.6206 20.8075 11.4436 17.6306 7.38505 16.385L6.94903 16.2512C11.1891 15.4396 14.5998 12.2895 15.745 8.1271L16 7.2002Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_411_13809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) rotate(90) scale(16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD00FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_13809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.0b7c3d1c899b7d792cf37eb8f4278eb7.svg";
export { ForwardRef as ReactComponent };